import {utcToZonedTime} from "date-fns-tz";

export const parseEnvNumberArray = (value?: string): number[] => {
  if (!value) return [];

  try {
    const parsedValue = JSON.parse(value);

    if (!Array.isArray(parsedValue)) {
      return [];
    }

    return parsedValue.filter(
      (item): item is number => typeof item === "number" && !Number.isNaN(item),
    );
  } catch {
    return [];
  }
};

export const parseEnvNumber = (value?: string): number | null => {
  if (!value) return null;

  const parsedValue = Number(value);

  return Number.isNaN(parsedValue) ? null : parsedValue;
};

export const DAYS_POSSIBLE_TO_POSTPONE_ACTIVITY =
  import.meta.env.VITE_DAYS_POSSIBLE_TO_POSTPONE_ACTIVITY ?? 10;

export const defaultTablePagination = {
  initialPage: 0,
  pageSize: 20,
};

export const DISABLE_VOYAGE_FUTURE_DATE: number[] = JSON.parse(
  import.meta.env.VITE_DISABLE_VOYAGE_FUTURE_DATE ?? `[]`,
);

export const TASK_IDS_SHOW_TAXES_VALIDITY_DATE: number[] = JSON.parse(
  import.meta.env.VITE_TASK_IDS_SHOW_TAXES_VALIDITY_DATE ?? `[]`,
);

export const TAXES_VALIDITY_PREDICTED_DISCHARGE_FIELD_ID: number | null =
  import.meta.env.VITE_TAXES_VALIDITY_PREDICTED_DISCHARGE_FIELD_ID
    ? Number(import.meta.env.VITE_TAXES_VALIDITY_PREDICTED_DISCHARGE_FIELD_ID)
    : null;

export const timeZone = "America/Sao_Paulo";
export const brazilianTimeZoneCurrentDate = utcToZonedTime(
  new Date(),
  timeZone,
);

export const containerNumberLength = 11;

export const TYPE_VOYAGES_TO_SHOW_IM = [
  "Coleta",
  "Transbordo / Escala",
  "Destino final",
  "Local Recebimento",
];
export const TYPE_VOYAGES_TO_SHOW_IA = [
  "Coleta",
  "Transbordo / Escala",
  "Destino final",
  "Entrega",
];

export const PROCESS_DETAILS_ROUTE = "process-details";

export const IM_TASK_PROJECT_ID = 1;
export const IA_TASK_PROJECT_ID = 2;

export const KEYCLOAK_REALM =
  import.meta.env.VITE_KEYCLOAK_REALM ?? "production";
export const KEYCLOAK_URL =
  import.meta.env.VITE_KEYCLOAK_URL ?? "https://iam.inext.net.br";
export const KEYCLOAK_CLIENT_ID =
  import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? "inext-client";
export const KEYCLOAK_MOBILE_CLIENT_ID =
  import.meta.env.VITE_KEYCLOAK_MOBILE_ID ?? "";

export const CUSTOM_TASK_IM_ID = import.meta.env.VITE_CUSTOM_TASK_IM_ID ?? 193;
export const CUSTOM_TASK_IA_ID = import.meta.env.VITE_CUSTOM_TASK_IA_ID ?? 194;

export const ACTIVITIES_TO_BLOCK_RESTORE: number[] = import.meta.env
  .VITE_ACTIVITIES_TO_BLOCK_RESTORE
  ? JSON.parse(import.meta.env.VITE_ACTIVITIES_TO_BLOCK_RESTORE)
  : [];

export const CCT_ACTIVITIES_IDS = {
  DECLARAR_CCT: Number(import.meta.env.VITE_DECLARAR_CCT_ID),
  CONFIRMAR_TRANSMISSAO_CCT: Number(
    import.meta.env.VITE_CONFIRMAR_TRANSMISSAO_CCT_ID,
  ),
};

export const ID_TASKS_TO_HIDE: number[] = import.meta.env.VITE_ID_TASKS_TO_HIDE
  ? JSON.parse(import.meta.env.VITE_ID_TASKS_TO_HIDE)
  : [];

export const ONLINE_RELEASE_WAITING_PAYMENT_STATUS_ID = Number(
  import.meta.env.VITE_ONLINE_RELEASE_WAITING_PAYMENT_STATUS_ID ?? 224,
);

export const ONLINE_RELEASE_FOR_CARRIER_RELEASE_STATUS_ID = Number(
  import.meta.env.VITE_ONLINE_RELEASE_FOR_CARRIER_RELEASE_STATUS_ID ?? 225,
);

export const ONLINE_RELEASE_WAITING_CARRIER_RELEASE_STATUS_ID = Number(
  import.meta.env.VITE_ONLINE_RELEASE_WAITING_CARRIER_RELEASE_STATUS_ID ?? 226,
);

export const ONLINE_RELEASE_ANALYSIS_STATUS_ID = Number(
  import.meta.env.VITE_ONLINE_RELEASE_ANALYSIS_STATUS_ID ?? 223,
);

export const ONLINE_RELEASE_RELEASED_STATUS_ID = Number(
  import.meta.env.VITE_ONLINE_RELEASE_RELEASED_STATUS_ID ?? 227,
);

export const LCL_PACKAGE_IDS = parseEnvNumberArray(
  import.meta.env.VITE_LCL_PACKAGE_IDS,
);

export const LCL_PACKAGE_DESTINATION_ID = parseEnvNumber(
  import.meta.env.VITE_LCL_PACKAGE_DESTINATION_ID,
);
